
// Module
// import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { androidstudio } from 'react-syntax-highlighter/dist/cjs/styles/hljs';

// CSS
import '_Asset/css/User/Page/develop.css'

// Component
import { useEffect, useState } from "react";
import axios from "axios";


let curApiParams;
const QueryParams = ({reqList, setReqList, apiUrl, setApiUrl, type, bodyIdx, setBodyIdx}) => {
  
  const [reqKey, setReqKey] = useState(); // key
  const [reqValue, setReqValue] = useState(); //value
  const [reqDescription, setReqDescription] = useState(); //description

  const [isIdx, setIsIdx] = useState();
  const [isList, setIsList] = useState();
  const [curChange, setCurChange] = useState()

  const bodyList = [
    {name: 'form-data', value: '0'},
    {name: 'x-www-form-urlencoded', value: '1'},
  ];


  let keyArr = [];
  // Set query params data
  useEffect(() => {
    curApiParams = '';

    let curParams;
    if (curChange === 'key') {
      curParams = reqKey;
    }
    else if (curChange === 'value') {
      curParams = reqValue;
    }

    if(curChange) {
      isList[`${curChange}`] = curParams;

      reqList.map((arr, i) => {
        if(arr.key !== '' || arr.value !== '') {
          const firstSp = i === 0 ? '?' : '&';
          keyArr.push(firstSp + arr.key + '=' + arr.value)
        }
      })

      const url = apiUrl.split('?')[0];
      keyArr.map(key => {
        curApiParams = curApiParams + key
      })

      if(type === "PARAMS") {
        setApiUrl(url + curApiParams);
      }
    }
    
    if(isList && (isList.key !== '' || isList.value !== '') && isIdx === reqList.length - 1) {
      setReqList([...reqList, {key: '', value: ''}])
    }

  }, [reqKey, reqValue, reqDescription, isList])


  return (
    <>
      {
        type === 'BODY' &&
        <div className="flexBox">
          {bodyList.map((key, i) => 
            <div className="checkGroup" key={i}>
              <input type="radio" id={key.name} value={key.value} checked={bodyIdx == key.value} onChange={(e) => setBodyIdx(e.target.value)}></input>
              <label htmlFor={key.name}>{key.name}</label>
            </div>
          )}
        </div>
      }
      <div className="table list_2">
        <table>
          <thead>
            <tr>
              <th className="check"><input type="checkbox" /></th>
              <th>KEY<i className="icofont-rounded-down"></i></th>
              <th>VALUE<i className="icofont-rounded-down"></i></th>
              <th>DESCRIPTION<i className="icofont-rounded-down"></i></th>
            </tr>
          </thead>
          <tbody>
            {
              reqList.map((list, i) =>
                <tr key={i} onChange={() => {setIsList(list); setIsIdx(i)}}>
                  <td><input type="checkbox" /></td>

                  <td><input type="text" className="input round_10 sm" onChange={(e) => {setReqKey(e.target.value); reqList[i].key = e.target.value; setCurChange('key'); }} value={reqList[i].key} placeholder={reqList.length - 1 === i ? 'Key' : ''}/></td>
                  <td><input type="text" className="input round_10 sm" onChange={(e) => {setReqValue(e.target.value); reqList[i].value = e.target.value; setCurChange('value'); }} value={reqList[i].value} placeholder={reqList.length - 1 === i ? 'Value' : ''}/></td>
                  <td><input type="text" className="input round_10 sm" onChange={(e) => {setReqDescription(e.target.value); reqList[i].description = e.target.value; setCurChange('description'); }} value={reqList[i].description} placeholder={reqList.length - 1 === i ? 'Description' : ''}/></td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    </>
  )
}

const TestingAPI = () => {

  // State, Data List
  const methodList = [
    'GET', 'POST', 'PATCH', 'DELETE', 'COPY', 'HEAD', 'OPTIONS', 'LINK', 'UNLINK',
    'PURGE', 'LOCK', 'UNLOCK', 'PROPFIND', 'VIEW'
  ]
  const [curMethod, setCurMethod] = useState('GET'); // 메소드 선택 Data
  const [apiUrl, setApiUrl] = useState(''); // API 주소
  const [curService, setCurService] = useState(); // APIs 제공 서비스 선택 Data
  
  const [queryString, setQueryString] = useState([ {key: '', value: ''} ]);
  const [body, setBody] = useState([ {key: '', value: ''} ]);
  const [header, setHeader] = useState([ {key: '', value: ''} ]);

  const [tabIdx, setTabIdx] = useState(0);
  const [bodyIdx, setBodyIdx] = useState(0);
  const tabArr = [
    { name: 'Params', component: <QueryParams reqList={queryString} setReqList={setQueryString} apiUrl={apiUrl} setApiUrl={setApiUrl} type="PARAMS"/>},
    { name: 'Headers', component: <QueryParams reqList={header} setReqList={setHeader} apiUrl={apiUrl} setApiUrl={setApiUrl} type="HEADER" />},
    { name: 'Body', component: <QueryParams reqList={body} setReqList={setBody} apiUrl={apiUrl} setApiUrl={setApiUrl} type="BODY" bodyIdx={bodyIdx} setBodyIdx={setBodyIdx}/>},
  ]
  const [sendRes, setSendRes] = useState();
  const [sendErr, setSendErr] = useState();

  const testApi = () => {

    let reqData = '';
    
    body.map(arr => {
      if(arr.key !== '') {
        if(bodyIdx == 0) {
          if(reqData === '') {
            reqData = new FormData;
          }
          reqData.append(arr.key, arr.value)
        } else {
          if(reqData === '') {
            reqData = {}
          }
          reqData[arr.key] = arr.value
        }
      }
    })
    
    axios({
      method: curMethod,
      url: apiUrl,
      data: reqData
    })
    .then(res => {
      // console.log("SUCCESS", res)
      setSendErr(undefined)
      setSendRes(res)
    })
    .catch(err => {
      // console.error("ERROR..", err)
      setSendRes(undefined)
      setSendErr(err)
    })
  }


  return (
    <>
      <div className="visual develop">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Testing APIs</h2>
            
            <p className="visualTxt">If you're testing an API, you can automate various parts of the process.</p>
          </div>
        </div>
      </div>
      
      <div className="mainContents">
        <div className="section">
         <div className="testApiArea areaBox">
            {/* API URL, Method, Service Setting */}
            <div className="settingBox">
              <fieldset>
                <div className="field full">
                  <select className="type_1 select round_10 sm" disabled>
                    <option value="0">Service Select</option>
                    <option value="1">Seyfert Remittance</option>
                    <option value="2">Seyfert P2P</option>
                    <option value="3">Seyfert PG</option>
                    <option value="4">Seyfert Wallet</option>
                  </select>

                  <select className="type_1 select round_10 sm" disabled>
                    <option value="">Access Key Select</option>
                    {/* <option value="">SvT3NzAoF0YKbY4-J-_atF6T_VsoKh9WiGrdeycGcj11mwAAAEE08H4</option> */}
                  </select>
                </div>

                <div className="field full">
                  <select className="type_1 select round_10 sm" onChange={(e) => setCurMethod(e.target.value)}>
                    {methodList.map((key, i) =>
                      <option key={i} value={key}>{key}</option>
                    )}
                  </select>

                  <input type="text" className="input round_10 sm" onChange={(e) => setApiUrl(e.target.value)} value={apiUrl} placeholder="API URL을 입력해주세요."/>
                </div>
              </fieldset>

              <button type="button" className="btn round_10 sm sfrtBlue" onClick={testApi}>Send</button>
            </div>

            {/* Query 전송 방식 Tab */}
            <div className="tabGroup type_2 sfrtBlue round_10">
              <div className="tabBar">
                {
                  tabArr.map((key, i) => 
                    <button type="button" key={i} className={`btn xs ${tabIdx === i ? 'active' : ''}`} onClick={() => setTabIdx(i)}>{key.name}</button>
                  )
                }
              </div>
            </div>

            {/* Query 전송 방식 콘텐츠 Component */}
            <div className="reqData">
              <h2>{tabArr[tabIdx].name}</h2>

              {tabArr[tabIdx].component}
            </div>

            {/* Response Data Contents */}
            <div className="resData">
              <h2>Response</h2>
              {
                sendRes === undefined && sendErr === undefined ?
                <div className="resMsgBox">
                  <p>Click Send to get a response.</p>
                </div>
                :
                sendRes ?
                // <p>{sendRes.message} {sendRes.response.data}</p>
                <SyntaxHighlighter language="json" style={androidstudio}
                  showLineNumbers={true}
                  wrapLines={true}
                >
                  {JSON.stringify(sendRes.data, null, '\t')}
                </SyntaxHighlighter>
                :
                <div className="resMsgBox">
                  <p>{sendErr.message}</p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TestingAPI;